import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from '@env/environment';
import { CourseService } from '@scaffold/services/course.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { SearchModalComponent } from '../../editor/controls/search-modal/search-modal.component';
import { NotificationMessageIcon } from '@app/framework/notification-sidebar/notification-sidebar.component';
import { NotificationsService } from '@services/notifications.service';
import { WebsocketService } from '@services/websocket.service';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from '@services/translation.service';


@Component({
  selector: 'app-exportmodal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss']
})
export class ExportModalComponent implements OnInit {

  @ViewChild('contentHolder', { static: false }) private itemElements: ElementRef;
  data: any = {};
  exportSocket: Observable<any>;
  socketSubscription: Subscription;
  constructor (
    private translationService:TranslationService,
    public dialogRef: NbDialogRef<ExportModalComponent>,
    private http: HttpClient,
    private courseService: CourseService,
    public dialog: NbDialogService,
    private notifications: NotificationsService,
    private socketService: WebsocketService,
    private httpClient: HttpClient
  ) { }
  url = environment.apiRoot + '/download/export';
  exportStarted = false;
  /*Array of export ids initiated form this instance of Scaffold*/
  exporting = [];
  /**Course level export definitions*/
  courseExports = [
    {
      label: 'Raw Data TXT',
      type: 'cvs',
      format: 'txt'
    }, {
      label: 'Raw Data CSV',
      type: 'cvs',
      format: 'csv'
    }, {
      label: 'Grade Table CSV',
      type: 'grades',
      format: 'csv'
    }, {
      label: 'Discussion Posts',
      type: 'discussionsHtml',
      format: 'html'
    }, {
      label: 'Submission Files',
      type: 'files',
      format: 'zip'
    }
  ];
  /** Student specific export definitions*/
  studentExports = [
    {
      label: 'Grade List by Student',
      type: 'gradesHtml',
      format: 'html'
    },
    {
      label: 'Raw Data CSV by Student',
      type: 'csv',
      format: 'csv'
    },
    {
      label: 'Raw Data TXT by Student',
      type: 'csv',
      format: 'txt'
    }, {
      label: 'Discussion Posts by Student',
      type: 'discussionsHtml',
      format: 'html'
    }, {
      label: 'Submission Files by Student',
      type: 'files',
      format: 'zip'
    }
  ];



  ngOnInit () {
    this.courseExports = [
      {
        label: this.translationService.getTranslatedContent('raw_data',"Raw Data"),
        type: 'cvs',
        format: 'txt'
      }, {
        label: this.translationService.getTranslatedContent('raw_data_csv',"Raw Data CSV"),
        type: 'cvs',
        format: 'csv'
      }, {
        label: this.translationService.getTranslatedContent('grade_table_csv',"Grade Table CSV"),
        type: 'grades',
        format: 'csv'
      }, {
        label: this.translationService.getTranslatedContent('discussion_posts',"Discussion Posts"),
        type: 'discussionsHtml',
        format: 'html'
      }, {
        label: this.translationService.getTranslatedContent('submission_files',"Submission Files"),
        type: 'files',
        format: 'zip'
      }
    ];


    this.studentExports = [
      {
        label: this.translationService.getTranslatedContent('grade_list_by_student','Grade List by Student'),
        type: 'gradesHtml',
        format: 'html'
      }, 
      {
        label: this.translationService.getTranslatedContent('raw_data_txt_student',"Raw Data TXT by Student"),
        type: 'cvs',
        format: 'txt'
      }, {
        label: this.translationService.getTranslatedContent('raw_data_csv_student',"Raw Data CSV by Student"),
        type: 'cvs',
        format: 'csv'
      },
      {
        label: this.translationService.getTranslatedContent('discussion_posts_by_student','Discussion Posts by Student'),
        type: 'discussionsHtml',
        format: 'html'
      }, {
        label: this.translationService.getTranslatedContent('submission_files_by_student','Submission Files by Student'),
        type: 'files',
        format: 'zip'
      }
    ];


    this.openSocket();
  }

  /**
   * Trigger events when begining an export
   * */
  startExport () {
    this.openSocket();
    this.exportStarted = true;
  }

  /**
   * Trigger a course level export defined in courseExports
   * @param type Type of export
   * @param format Format of export
   */
  getData (type, format) {
    this.startExport();
    this.http.get(environment.apiRoot + `/download/${type}?course_id=${this.courseService.id}&file_format=${format}`).subscribe(data => {
      this.exporting.push(data['request']);
      this.exportStarted = false;
    });
  }


  /**
   * Trigger the flow to select a student and initate an export for that student defined in studentExports
   * @param type
   */
  byStudent (type, format): void {
    this.startExport();
    const settings: any = {
      context: {
        data: {
          context: { type: 'courses', id: this.courseService.id },
          paginate_results: true,
          type: 'data_search',
          search_type: 'archiveusers',
          search_mode: "list",
          window_title: 'Select Student',
          prevent_create: true,
        },
      },
    };
    let searchRef = this.dialog.open(SearchModalComponent, settings);

    searchRef.onClose.subscribe((result) => {
      console.log(result);
      if (result) {

        this.http.get(environment.apiRoot + `/download/${type}?course_id=${this.courseService.id}&file_format=${format}&student=${result}`).subscribe(data => {
          this.exportStarted = false;
          this.exporting.push(data['request']);
        });
      } else {
        this.exportStarted = false;

      }
    });
  }

  /**
   * Open/refresh websocket used for watching status of export
   */
  openSocket () {
    if (this.socketSubscription?.unsubscribe) {
      this.socketSubscription.unsubscribe();
    }
    this.exportSocket = this.socketService.refreshSocket();

    this.socketSubscription = this.exportSocket.subscribe(message => {
      if (message?.Status === "Listener set.") {
        console.log("Listener Set");
      } else {
        this.addNotification(message);
        if (message.url) {
          Array.isArray(message.url)?message.url.forEach(url=>this.completeRequest(message,url)):this.completeRequest(message);
        }
      }


    });
  }
  /**
   * Add an export notification to the user notification sidebar
   * @param data object containing data about an export
   */
  addNotification (data) {
    if (this.exporting.includes(data.requestId)) {
      this.notifications.addUserNotification(
        {
          icon: NotificationMessageIcon.fileZip,
          progress: data.progress,
          text: data.details,
          status: (data.progress || 0) + '%',
          shouldForceOpen: true,
        },
        data.requestId
      );
    }
  }

  /**
   * Complete download of export after recieving the socket notification that it has completed
   * @param data
   */
  completeRequest (data,url?) {
    let signedUrl = url || data.url;
    if (this.exporting.includes(data.requestId)) {
      this.httpClient
        .get(signedUrl, {
          responseType: "blob",
          reportProgress: true,
          observe: 'events'
        })
        .subscribe(
          (res) => {
            
            if (res.type === HttpEventType.DownloadProgress) {
              const percentDone = Math.round(100 * res.loaded / res.total);
              this.notifications.addUserNotification(
                {
                  icon: NotificationMessageIcon.fileZip,
                  text:  this.translationService.getTranslatedContent('downloading_export','Downloading export'),
                  progress: percentDone,
                  status: this.translationService.getTranslatedContent('downloading','Downloading') ,
                },
                data.requestId
              );
            }
            if (res.type === HttpEventType.Response) {
              const blob = new Blob([res.body], {
                type: data.type,
              });
              const a = document.createElement("a");
              const url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = data.title;
              a.click();
              window.URL.revokeObjectURL(url);
              this.notifications.addUserNotification(
                {
                  icon: NotificationMessageIcon.checkmark,
                  text: this.translationService.getTranslatedContent('export_downloaded','Export Downloaded'),
                  progress: 100,
                  status:  this.translationService.getTranslatedContent('download_complete','Download Complete'),
                },
                data.requestId
              );
            }
          },
          (err) => {
          }
        );
    }
  }

}
